import { EmptyArray } from 'lib/array/arrayUtils'

/**
 * Resolves the opt-in bundle a room has selected against the bundles its *current* rate actually
 * offers. State stores only the bundle id, so a selection that no longer matches the rate on screen (a
 * race between a rate refresh and a reducer reset) resolves to nothing rather than to a price the
 * shopper can no longer see.
 *
 * Returns an array because `propertyMultiRoomBuyCallback` takes a list per room, but it holds at
 * most one entry — see `OfferPageRoom.optionalBundleId` for that invariant.
 */
export function resolveSelectedOptionalBundles(
  rate: App.EnrichedPropertyRate | undefined,
  selectedBundleIds: Array<string> | undefined,
): Array<App.Property.OptionalBundle> {
  if (!rate || !selectedBundleIds?.length) return EmptyArray
  const selectedBundles = (rate.optionalBundles ?? []).filter(({ bundleId }) => selectedBundleIds.includes(bundleId))
  return selectedBundles.length ? selectedBundles : EmptyArray
}

/** Total a room's selected bundles add on top of its hotel rate. Display-time only. */
export function getSelectedOptionalBundlesPrice(
  rate: App.EnrichedPropertyRate | undefined,
  selectedBundleId: string | undefined,
): number {
  let total = 0
  for (const optionalBundle of resolveSelectedOptionalBundles(rate, selectedBundleId ? [selectedBundleId] : undefined)) {
    total += optionalBundle.totalPrice
  }
  return total
}
